import React,{useState,useEffect ,useContext} from 'react';
import { Ordinazione, Passaggio } from '../App';
import '../Cibi/Cibi.css'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
let car=[];

const Cibi = () => {
    
    const ContestoOrdinazione=useContext(Ordinazione)
    const Contesto=useContext(Passaggio)
    const [cibi,setcibi]=useState([])
    const link=useNavigate() 
    useEffect(() => {
        //Salvo l'ordine nella variabile 'car'
        car=Contesto.ordine
	}, [Contesto.ordine]);
    useEffect(() => {
        ScaricaCibi();
    }, [])
    if(sessionStorage.getItem("token")===null){
        link("/")
    }
    //Fetch per scaricare cibi
    const ScaricaCibi =()=>{
        //Costruisco URL con info salvate in sessione (grazie al sessionStorage posso passare idCitta e idLocali)
        let url= `http://37.60.34.42:8080/getProdotti?citta_id=${sessionStorage.getItem('idCitta')}&locali_id=${sessionStorage.getItem('idLocale')}`
        fetch(url)
        .then(response => response.json())
        .then(data=>{
            
                    setcibi([<div className='categoria'>Cibi</div>])
                    let informazione= []
                    //Inserisco le info nel vettore 'informazione'
                    //Cibi salati
                    data.cibi.salato.forEach((cibo,indice)=>{
                        informazione.push(
                        <div key={indice} className='pulsante' >   
                            <div className='formattatesto' >{cibo.nome}</div>
                            <div className='formattainfo' >PREZZO: {cibo.prezzo}€</div>
                            <div className='aggiungi' onClick={()=>{aggiungi(cibo)}}><div className='sposta'>+</div></div>
                        </div>
                        )
                    })
                    //Cibi dolci
                    data.cibi.dolce.forEach((cibo,indice)=>{
                        informazione.push(
                        <div key={indice+100} className='pulsante' >   
                        <div className='formattatesto'>{cibo.nome}</div>
                        <div className='formattainfo'>PREZZO: {cibo.prezzo}€</div>
                        <div className='aggiungi' onClick={()=>{aggiungi(cibo)}}><div className='sposta'>+</div></div>
                        </div>
                        )
                    })
                    setcibi(cibi=>[...cibi,informazione])
                    setcibi(cibi=>[...cibi,<div className='categoria' >Bevande</div>])
                    //Bevande
                    let informazioneb= []
                    data.bevande.forEach((bb,indice)=>{
                        informazioneb.push(
                        <div key={indice+200} className='pulsante' >   
                        <div className='formattatesto' >{bb.nome}</div>
                        <div className='formattainfo'>PREZZO: {bb.prezzo}€</div>
                        <div className='aggiungi' onClick={()=>{aggiungi(bb)}}><div className='sposta'>+</div></div>
                        </div>
                        )
                        
                    })
                    setcibi(cibi=>[...cibi,informazioneb])
                    //Menù
                    if(data.menu.length!=0){
                        setcibi(cibi=>[...cibi,<div className='categoria' >Menu</div>])
                        let informazionem=[];
                        data.menu.forEach((mn,indice)=>{
                            informazionem.push(
                            <div key={indice+400} className='pulsante' >   
                            <div className='formattatesto' >{mn.nome}</div>
                            <div className='formattainfo'>PREZZO: {mn.prezzo}€</div>
                            <div className='aggiungi' onClick={()=>{aggiungi(mn)}}><div className='sposta'>+</div></div>
                            </div>
                            )
                            var car=Contesto.ordine
                        })
                        setcibi(cibi=>[...cibi,informazionem])
                    }
            })
    }
    //Funzione per creare l'oggetto dell'ordine
    //Mi salvo le info relative a quel prodotto (come il suo id, il suo nome, il suo prezzo, la quantità e il locale che fa questo prodotto)
    const creaOggettoOrdine =(el)=>{
        let ordinazione={
            idProd: el.id,
            prodotto: el.nome,
            prezzo: el.prezzo,
            qta: 1,
            idLocale: sessionStorage.getItem('idLocale')
        }
        //Salvo l'oggetto nello stato
        Contesto.setordine(ordinaz=>[...ordinaz,ordinazione])
        //Aggiorno lo stato del prezzo
        Contesto.settotale(totale=>totale+el.prezzo)
    }
    //Aggiungi prodotti
    const aggiungi = (el)=>{
        let altroLocale=true
        //Flag per verificare la presenza del prodotto
        let presente=false
        //Se il carrello non è vuoto, allora passo al controllo
        //
        Swal.fire({  title: 'Articolo inserito nel carrello!', timer:1500,showConfirmButton:false,  icon: 'success', width:"65vw"})    
        
        if(car.length !== 0){
        //Se tutto ciò che è nel carrello ha id del locale uguale a quello salvato in sessione, allora controllo id dei cibi
            if(car[0].idLocale === sessionStorage.getItem('idLocale')){
                //Ciclo nel carrello
                car.forEach(element => {
                    //Se l'id del prodotto è uguale ad un prodotto già presente, allora incremento qta
                    if (element.idProd === el.id) {
                        presente=true
                        element.qta+=1;
                        //Aggiorno prezzo totale
                        Contesto.settotale(totale=>totale+el.prezzo)
                    }
                });
                
                //Se non è presente, allora richiamo la funzione per creare l'ordine del prodotto inserito
                if(!presente){
                    creaOggettoOrdine(el)
                }else{
                    //Se è presente, setto l'ordine
                    
                    Contesto.setordine(car)

                }
            }else{
                altroLocale=false
                //Se gli id dei locali non corrispondono stampo un mex d'errore
                Swal.fire({  title: 'Puoi acquistare da un solo Locale!', timer:1500,showConfirmButton:false,  icon: 'warning', width:"65vw"})    

            }
        }else{
            creaOggettoOrdine(el)
        }
        if(altroLocale){
            Contesto.setqta((qta) =>qta+1)
        }
        
    }
    //Visualizzo cibi
    return (
        <div id='contcibi'>
            {cibi}
        </div>
    )
}

export default Cibi